import Page from '@/found/components/table_page';
import Form from '../form/index';

export default {
  name: 'marketing_activity_list',
  extends: Page,
  data() {
    return {
      params: {
        actType: 'project',
        approveType: 'N',
      },
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('marketing_activity_close');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      const { approveStatus, processCode } = row;
      //   if (code === 'process_log' && !processCode) {
      //     return false;
      //   }

      //   if (approveStatus && code === 'submit_approval' && approveStatus !== 'rejected' && approveStatus !== 'create') {
      //     return false;
      //   }
      //   if (approveStatus && code === 'edit' && approveStatus !== 'rejected' && approveStatus !== 'create') {
      //     return false;
      //   }
      return true;
    },

    modalClick({ val, row }) {
      const { code } = val;
      console.log('code', code);
      if (code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = code === 'edit' ? '编辑' : '查看';
        this.openFull();
      }
    },
  },
};
